import type { Receita } from '../../types';
import { LinhaReceita } from './LinhaReceita';

interface Props {
  receitas: Receita[];
  carregando?: boolean;
  onEditar: (r: Receita) => void;
  onReceber: (r: Receita) => void;
  onExcluir: (r: Receita) => void;
}

export function TabelaReceitas({ receitas, carregando, onEditar, onReceber, onExcluir }: Props) {
  if (carregando) {
    return <div className="text-center text-xs text-slate-400 py-12">Carregando…</div>;
  }
  if (!receitas.length) {
    return (
      <div className="text-center text-sm text-slate-400 dark:text-slate-500 py-12 border border-dashed border-slate-200 dark:border-slate-700 rounded-xl">
        Nenhuma receita cadastrada. Clique em <span className="font-medium">“Nova receita”</span> para começar.
      </div>
    );
  }
  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900/40">
      <table className="w-full">
        <thead className="bg-slate-50 dark:bg-slate-800/60 text-slate-500 dark:text-slate-400">
          <tr className="text-[11px] uppercase tracking-wide">
            <th className="text-left px-3 py-2 font-medium">Processo / cliente / divisão</th>
            <th className="text-right px-3 py-2 font-medium">Contratuais</th>
            <th className="text-right px-3 py-2 font-medium">Sucumbência</th>
            <th className="text-right px-3 py-2 font-medium">Total</th>
            <th className="text-center px-3 py-2 font-medium">Status</th>
            <th className="text-left px-3 py-2 font-medium">Data</th>
            <th className="px-3 py-2"></th>
          </tr>
        </thead>
        <tbody>
          {receitas.map((r) => (
            <LinhaReceita key={r.id} r={r} onEditar={onEditar} onReceber={onReceber} onExcluir={onExcluir} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
